<script>
    import { setContext } from 'svelte';
    import { writable, derived } from 'svelte/store';
    import { json, csv } from 'd3-fetch';
    
    const threshold = writable(0.40);
    const streets = writable({});
    json('./Abila.geojson').then(res => {
        $streets = res;
    });

    const points = writable([]);
    json('./gps_cor_activity_no_phate.json').then(res => {
        $points = res;
    });

    const distances = writable([]);
    csv('./gps_activity_correlation_distances.csv').then(res => {
        $distances = res;
    });

    const traces = writable([]);
    csv('./gps_activity_traces.csv').then(res => {
        $traces = res;
    });
    const hoverIdx = writable(null);


    const isActive = derived([points, hoverIdx, threshold], ([$points, $hoverIdx, $threshold]) => {
        if ($distances.length == 0 || !$hoverIdx) {
            return $points.map(() => true);
        }

        const dists = $distances[$hoverIdx];
        const keys = Object.keys(dists);
        return $points.map((p, i) => {
            return dists[keys[i]] <= $threshold;
        });
    })

    const key = {};
    setContext(key, {
        streets, points, distances, traces, isActive, hoverIdx, threshold
    });
</script>

<!-- <svelte:window on:beforeunload={beforeUnload}/> -->

<slot {key} />